module.exports = __webpack_public_path__ + "media/4x3/id-17b99676.svg";